import React, { Component } from 'react';
import { Map, TileLayer, GeoJSON, WMSTileLayer } from 'react-leaflet';

const mapCenter = [12.34536, 104.96337];
const zoomLevel = 6;

const hereUrl = 'https://{s}.{base}.maps.cit.api.here.com/maptile/2.1/{type}/{mapID}/normal.day/{z}/{x}/{y}/{size}/{format}?app_id={app_id}&app_code={app_code}&lg={language}';
const hereAttrib = 'Map &copy; 1987-2014 <a href="http://developer.here.com">HERE</a>';

const appId = 'DQJyxQyME0TTY0bzupo2';
const appCode = '92CAu-TK_KmuDw_y_qbb1w';

const borderColor = "#005703";
const selectedStyle = "#E63946";
const mouseOverFillColor = '#C0D9E5';

const lakeFillColor = '#80C5E5';
const landFillColor = '#5FAA68';

const jsonEndpoint = 'api/boundary';
// ids of catchments to remove since they are not in Cambodia
const ignoreCatchmentIds = [0, 1, 4, 27, 29];

export default class SubcatchmentMap extends Component {
    constructor(props) {
        super(props);
        this.styleLand = this.styleLand.bind(this);
        this.styleLake = this.styleLake.bind(this);
        this.state = { selectedFeature: {} };
    }

    async componentDidMount() {
        const response = await fetch(`${jsonEndpoint}/HistoricBoundary`);
        const catchments = await response.json();
        
        if (!this.isCancelled) {
            this.setState({ catchmentJson : catchments}, async () => {
                const lakeResponse = await fetch(`${jsonEndpoint}/LakeBoundary`);
                const lake = await lakeResponse.json();
                
                if (!this.isCancelled) {

                    this.setState({lakeJson: lake}, async () => {
                        const countryResponse = await fetch(`${jsonEndpoint}/CountryBorder`);
                        const countryBorder = await countryResponse.json();

                        if (!this.isCancelled) {

                            this.setState({ countryBorderJson: countryBorder });
                        }
                    });
                }
            })
        }
    }

    componentWillUnmount() {
        this.isCancelled = true;
    }

    styleCountry(feature) { 
        return {
            weight: 3,
            fillColor: 'transparent',
            color: 'black',
            interactive: false
        };
    }
    styleLake(feature) {
        if (feature === this.state.selectedFeature) {
            return {
                weight: 5,
                fillColor: selectedStyle,
                color: borderColor,
                dashArray: '',
                fillOpacity: 0.7
            };
        }
        else {
            var color = lakeFillColor;
            if (this.props.colors !== undefined) {
                color = this.props.colors[feature.id];
            }
            return {
                fillColor: color,
                weight: 2,
                opacity: 1,
                color: borderColor,
                fillOpacity: 0.7
            };
        }

    }

    styleLand(feature) {
        const opacity = 0.3;
        if (feature === this.state.selectedFeature) {
            return {
                weight: 3,
                fillColor: selectedStyle,
                color: borderColor,
                dashArray: '',
                fillOpacity: opacity
            };
        }
        else {
            var color = landFillColor;
            if (this.props.colors !== undefined) {
                color = this.props.colors[feature.id];
            }
            return {
                fillColor: color,
                weight: 2,
                opacity: 1,
                color: borderColor,
                dashArray: '3',
                fillOpacity: opacity
            };
        }
    }

    // highlight on mouseOver
    highlightFeature(e) {
        var layer = e.target;

        layer.setStyle({
            weight: 3,
            fillColor: mouseOverFillColor,
            color: borderColor,
            dashArray: '',
            fillOpacity: 0.5
        });
    };

    selectFeature(layer) {
        layer.setStyle({
            weight: 5,
            fillColor: selectedStyle,
            color: borderColor,
            dashArray: '',
            fillOpacity: 0.7
        })
    }

    // reset default style on mouseOut
    resetHighlight(e, isLand) {
        if (isLand) {
            this.geojson.leafletElement.resetStyle(e.target);
        }
        else {
            this.lakeData.leafletElement.resetStyle(e.target);
        }
    };

    resetLake(e) {
        this.resetHighlight(e, false);
    }

    resetLand(e) {
        this.resetHighlight(e, true);
    }

    clickFeature(e) {
        var layer = e.target;
        this.setState({ selectedFeature: layer.feature });
        this.props.click(layer.feature);
    }

    clickLake(e) {
        var layer = e.target;
        this.setState({ selectedFeature: layer.feature });
    }

    onEachFeature(e, layer) {
        layer.on({
            mouseover: this.highlightFeature,
            mouseout: this.resetLand.bind(this),
            click: this.clickFeature.bind(this)
        });
    }

    onEachLake(e, layer) {
        layer.on({
            mouseover: this.highlightFeature,
            mouseout: this.resetLake.bind(this),
            click: this.clickLake.bind(this)
        });
    }

    render() {
        const dynamicMapStyle = {
            'width': Math.floor(this.props.width),
            'height': '440px',
        };

        var catchments = undefined;
        if (this.state.catchmentJson) {
            catchments = (
                <GeoJSON
                    filter={SubcatchmentMap.filterCatchments}
                    data={this.state.catchmentJson}
                    style={this.styleLand}
                    onEachFeature={this.onEachFeature.bind(this)}
                    ref={m => { this.geojson = m; }}
                />
            );
        }

        var lake = undefined;
        if (this.state.lakeJson) {
            lake = (
                <GeoJSON
                        data={this.state.lakeJson}
                        style={this.styleLake}
                        filter={this.showOnlyLake}
                        onEachFeature={this.onEachLake.bind(this)}
                        ref={m => { this.lakeData = m; }}
                    />
            );
        }
        
        let border;
        if (this.state.countryBorderJson) {
            border = (
                <GeoJSON
                    data={this.state.countryBorderJson}
                    style={this.styleCountry}
                />
            );
        }
        return (
            <div>
                <Map
                    ref={m => { this.leafletMap = m; }}
                    style={dynamicMapStyle}
                    center={mapCenter}
                    zoom={zoomLevel}
                >
                    <TileLayer
                        attribution={hereAttrib}
                        url={hereUrl}
                        subdomains='1234'
                        app_id={appId}
                        app_code={appCode}
                        base='base'
                        language='eng'
                        type='maptile'
                        format='png8'
                        mapID='newest'
                        size='256'
                    />
                    {catchments || ""}
                    {lake || ""}
                    {border || ""}
                </Map>
            </div>
        );
    }

    showOnlyLake(feature) {
        return feature.properties.Lake_name === "Tonle Sap";
    }
    
    static filterCatchments(feature) {
        return !ignoreCatchmentIds.includes(feature.id);
    }
}


// WEBPACK FOOTER //
// ./src/components/SubcatchmentMap.jsx